var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isAway)?_c('div',{staticClass:"away-overlay d-flex justify-center align-center"},[_c('div',{staticClass:"text-center pa-4 white--text"},[_c('div',{staticClass:"title mt-2",staticStyle:{"max-width":"600px"},domProps:{"textContent":_vm._s(
					_vm.$t(
						'Your session has ended due to inactivity. You will be redirected to the login page in 10 seconds.'
					)
				)}})])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }